var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRocketOrange = function SvgRocketOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "rocket--orange_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".rocket--orange_svg__st1{fill:#0b1b34}.rocket--orange_svg__st2{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}.rocket--orange_svg__st3,.rocket--orange_svg__st5{fill:#ff7101}.rocket--orange_svg__st5{fill-rule:evenodd;clip-rule:evenodd}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "rocket--orange_svg__SVGID_1_",
    d: "M0 0h80v80H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "rocket--orange_svg__SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rocket--orange_svg__SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#rocket--orange_svg__SVGID_2_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 17.6v-.8c1.8 0 3.2-1.4 3.2-3.2H8c0 1.8 1.4 3.2 3.2 3.2v.8C9.4 17.6 8 19 8 20.8h-.8c0-1.7-1.4-3.2-3.2-3.2z",
    className: "rocket--orange_svg__st1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 13.6c0-.4.4-.8.8-.8H8c.4 0 .8.4.8.8 0 1.3 1.1 2.4 2.4 2.4.4 0 .8.4.8.8v.8c0 .4-.4.8-.8.8-1.3 0-2.4 1.1-2.4 2.4 0 .4-.4.8-.8.8h-.8c-.4 0-.8-.4-.8-.8 0-1.3-1.1-2.4-2.4-2.4-.4 0-.8-.4-.8-.8v-.8c0-.4.4-.8.8-.8 1.3 0 2.4-1.1 2.4-2.4zm1.2 1.8c-.4.8-1.1 1.5-1.9 1.9.8.4 1.5 1.1 1.9 1.9.4-.8 1.1-1.5 1.9-1.9-.8-.5-1.5-1.1-1.9-1.9z",
    className: "rocket--orange_svg__st2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 41.6c1.5 0 2.8-1.3 2.8-2.8 0-1.5-1.3-2.8-2.8-2.8s-2.8 1.3-2.8 2.8c0 1.6 1.3 2.8 2.8 2.8z",
    className: "rocket--orange_svg__st3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 36.8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-3.6 2c0-2 1.6-3.6 3.6-3.6s3.6 1.6 3.6 3.6-1.6 3.6-3.6 3.6-3.6-1.6-3.6-3.6zM82.2 61.8c-.5 0-1 .4-1 1s.4 1 1 1c.5 0 1-.4 1-1s-.4-1-1-1zm-2.5.9c0-1.4 1.1-2.6 2.6-2.6 1.4 0 2.6 1.1 2.6 2.6 0 1.4-1.1 2.6-2.6 2.6s-2.6-1.2-2.6-2.6z",
    className: "rocket--orange_svg__st2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9 63.6h-7.6l-3.2-8.2h14.1l-3.3 8.2z",
    className: "rocket--orange_svg__st1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 54.9c.1-.2.4-.3.7-.3h14.1c.3 0 .5.1.7.4.1.2.2.5.1.7l-3.3 8.2c-.1.3-.4.5-.7.5h-7.6c-.3 0-.6-.2-.7-.5l-3.2-8.2c-.3-.3-.3-.6-.1-.8zm1.8 1.2 2.6 6.6h6.5l2.6-6.6H34.3z",
    className: "rocket--orange_svg__st2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m35.4 58.3-13 5.3 13-30.6v25.3z",
    className: "rocket--orange_svg__st3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6 32.2c.4.1.6.4.6.8v25.4c0 .3-.2.6-.5.7l-13 5.3c-.3.1-.6.1-.9-.2-.2-.2-.3-.6-.2-.9l13-30.6c.3-.4.6-.6 1-.5zM23.9 62.1l10.7-4.4V36.9L23.9 62.1z",
    className: "rocket--orange_svg__st2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m45 58.3 13 5.3-13-30.7v25.4z",
    className: "rocket--orange_svg__st3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8 32.2c.4-.1.7.1.9.5l13 30.6c.1.3.1.6-.2.9-.2.2-.6.3-.9.2l-13-5.3c-.3-.1-.5-.4-.5-.7V32.9c.1-.3.3-.7.7-.7zm1 4.7v20.9l10.7 4.4-10.7-25.3z",
    className: "rocket--orange_svg__st2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4 58.3H33.8l-4.4-33.8c-.8-7.6 2.9-15.1 8.4-20.4 1.3-1.2 3.3-1.2 4.6 0 5.5 5.3 9.2 12.8 8.4 20.4l-4.4 33.8z",
    className: "rocket--orange_svg__st3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4 4.7c-5.4 5.2-8.9 12.4-8.2 19.7l4.3 33.1h11.2L50 24.4c.8-7.3-2.8-14.6-8.2-19.7-.9-.9-2.4-.9-3.4 0zm-1.1-1.2C38.9 2 41.4 2 43 3.5c5.6 5.4 9.5 13.2 8.6 21.1l-4.4 33.8c-.1.4-.4.7-.8.7H33.8c-.4 0-.7-.3-.8-.7l-4.4-33.8c-.8-7.9 3-15.7 8.7-21.1z",
    className: "rocket--orange_svg__st2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2 25.7c2.7 0 5-2.2 5-5 0-2.7-2.2-5-5-5s-5 2.2-5 5c0 2.7 2.2 5 5 5z",
    className: "rocket--orange_svg__st1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2 16.5c-2.3 0-4.2 1.9-4.2 4.2s1.9 4.2 4.2 4.2 4.2-1.9 4.2-4.2-1.9-4.2-4.2-4.2zm-5.8 4.2c0-3.2 2.6-5.8 5.8-5.8 3.2 0 5.8 2.6 5.8 5.8 0 3.2-2.6 5.8-5.8 5.8-3.2-.1-5.8-2.6-5.8-5.8zM39.4 58.3v-17H41v17h-1.6z",
    className: "rocket--orange_svg__st2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.6 76.8V64.4h1.6v12.4h-1.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#0b1b34"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1 73.2v-8.8h1.6v8.8h-1.6zM43.1 73.2v-8.8h1.6v8.8h-1.6z",
    className: "rocket--orange_svg__st5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3 14.8c-.2-2.3-1.9-4.2-4.3-4.4-1.7-.2-3.3.6-4.2 1.9-.3.5-.6 1-.7 1.5-.1.2-.2.6-.2.8-.2 2.6 1.7 4.9 4.2 5.1 2.2.2 4.3-1.2 5-3.4.1-.3.2-.6.2-1v-.5z",
    className: "rocket--orange_svg__st3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1 9.6c2.8.2 4.9 2.5 5.1 5.1v.5c0 .1 0 .2-.1.4 0 .4-.1.7-.2 1-.7 2.5-3.2 4.2-5.8 3.9-3-.3-5.2-2.9-5-6 0-.4.1-.7.2-1 .2-.6.5-1.2.8-1.7 1.1-1.4 3-2.4 5-2.2zm-3.7 3.2c-.3.4-.5.8-.6 1.3-.1.2-.1.4-.1.5v.1c-.2 2.2 1.4 4.1 3.5 4.3 1.8.2 3.6-1 4.1-2.8.1-.3.1-.5.1-.7 0-.1 0-.2.1-.3V15c-.1-1.9-1.6-3.5-3.6-3.6-1.4-.3-2.7.3-3.5 1.4z",
    className: "rocket--orange_svg__st2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9 16.5c1.1 0 2.1-.9 2.1-2.1 0-1.1-.9-2.1-2.1-2.1-1.1 0-2.1.9-2.1 2.1 0 1.2.9 2.1 2.1 2.1z",
    className: "rocket--orange_svg__st3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9 13.1c-.7 0-1.3.6-1.3 1.3 0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3zM56 14.4c0-1.6 1.3-2.9 2.9-2.9 1.6 0 2.9 1.3 2.9 2.9s-1.3 2.9-2.9 2.9c-1.6 0-2.9-1.3-2.9-2.9z",
    className: "rocket--orange_svg__st2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4 36.8V36c1.8 0 3.2-1.4 3.2-3.2h.8c0 1.8 1.4 3.2 3.2 3.2v.8c-1.8 0-3.2 1.4-3.2 3.2h-.8c0-1.7-1.4-3.2-3.2-3.2z",
    className: "rocket--orange_svg__st1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8 32.8c0-.4.4-.8.8-.8h.8c.4 0 .8.4.8.8 0 1.3 1.1 2.4 2.4 2.4.4 0 .8.4.8.8v.8c0 .4-.4.8-.8.8-1.3 0-2.4 1.1-2.4 2.4 0 .4-.4.8-.8.8h-.8c-.4 0-.8-.4-.8-.8 0-1.3-1.1-2.4-2.4-2.4-.4 0-.8-.4-.8-.8V36c0-.4.4-.8.8-.8 1.3 0 2.4-1.1 2.4-2.4zm1.2 1.7c-.4.8-1.1 1.5-1.9 1.9.8.4 1.5 1.1 1.9 1.9.4-.8 1.1-1.5 1.9-1.9-.8-.4-1.5-1.1-1.9-1.9z",
    className: "rocket--orange_svg__st2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8 56v-1.6c1.8 0 3.2-1.4 3.2-3.2h1.6c0 1.8 1.4 3.2 3.2 3.2V56c-1.8 0-3.2 1.4-3.2 3.2H68c0-1.8-1.4-3.2-3.2-3.2z",
    className: "rocket--orange_svg__st3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2 51.2c0-.4.4-.8.8-.8h1.6c.4 0 .8.4.8.8 0 1.3 1.1 2.4 2.4 2.4.4 0 .8.4.8.8V56c0 .4-.4.8-.8.8-1.3 0-2.4 1.1-2.4 2.4 0 .4-.4.8-.8.8H68c-.4 0-.8-.4-.8-.8 0-1.4-1.1-2.4-2.4-2.4-.4 0-.8-.4-.8-.8v-1.6c0-.4.4-.8.8-.8 1.3 0 2.4-1.1 2.4-2.4zm1.5.8c-.3 1.6-1.6 2.8-3.1 3.1v.2c1.6.3 2.8 1.5 3.1 3.1h.2c.3-1.6 1.6-2.8 3.1-3.1v-.2c-1.6-.3-2.8-1.6-3.1-3.1h-.2z",
    className: "rocket--orange_svg__st2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2 34.7c1 0 1.8-.8 1.8-1.8s-.8-1.8-1.8-1.8-1.8.8-1.8 1.8.8 1.8 1.8 1.8z",
    className: "rocket--orange_svg__st3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2 32c-.5 0-1 .4-1 1 0 .5.4 1 1 1s1-.4 1-1c-.1-.6-.5-1-1-1zm-2.6 1c0-1.4 1.1-2.6 2.6-2.6 1.4 0 2.6 1.1 2.6 2.6 0 1.4-1.1 2.6-2.6 2.6-1.5-.1-2.6-1.2-2.6-2.6z",
    className: "rocket--orange_svg__st2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 60.4c1 0 1.8-.8 1.8-1.8s-.8-1.8-1.8-1.8-1.8.8-1.8 1.8.8 1.8 1.8 1.8z",
    className: "rocket--orange_svg__st1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 57.6c-.5 0-1 .4-1 1 0 .5.4 1 1 1s1-.4 1-1c-.1-.6-.5-1-1-1zm-2.6 1c0-1.4 1.1-2.6 2.6-2.6 1.4 0 2.6 1.1 2.6 2.6 0 1.4-1.1 2.6-2.6 2.6-1.5-.1-2.6-1.2-2.6-2.6z",
    className: "rocket--orange_svg__st2"
  }))));
};
export default SvgRocketOrange;